<template>
  <BaseInput
    v-bind="$attrs"
    :label="label"
    :rules="rulePhone"
    :required="required"
  />
</template>

<script setup lang="ts">
import { string } from 'yup'
import { parsePhoneNumber } from 'libphonenumber-js/max'
import { isEmpty } from 'lodash-es'
import { computed } from 'vue'
import BaseInput from '~/base/components/input/Input.vue'

const props = defineProps({
  label: { type: String, default: 'Telefonnummer' },
  required: { type: Boolean, default: false }
})

const REGEX_PHONE = /^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s/0-9]*$/

const rulePhone = computed(() => {
  const phoneValidator = (value: string | undefined) => {
    let isValid = !props.required
    if (value) {
      try {
        const type = parsePhoneNumber(value, 'DE').getType()
        isValid = !isEmpty(type)
      } catch (error) {
        isValid = false
      }

      // double check for alphabetic values after parsing (because the library doesn't)
      if (isValid) {
        isValid = isValid = REGEX_PHONE.test(value)
      }
    }
    return isValid
  }

  return string().test(
    'is-phone',
    'Bitte geben Sie eine gültige Telefonnummer ein',
    phoneValidator
  )
})
</script>
